import { useEffect } from 'react';
import { useSession } from '@/store/session';
import { getAuthToken, getUser, clearAuthData } from '@/core/auth';
import { authApi } from '@/features/auth/api';

export const useAuth = () => {
  const { user, token, setSession, clearSession, isAuthenticated } = useSession();

  useEffect(() => {
    const storedToken = getAuthToken();
    const storedUser = getUser();

    if (storedToken && storedUser) {
      setSession(storedToken, storedUser);
    }
  }, [setSession]);

  const logout = async () => {
    try {
      await authApi.logout();
    } catch (e) {
      // ignore server errors to ensure client logout
    } finally {
      clearAuthData();
      clearSession();
    }
  };

  // Normalize role across possible shapes from backend
  const rawRole: any = (user as any)?.role_name ?? (user as any)?.roleName ?? (user as any)?.role ?? (user as any)?.role_id ?? (user as any)?.roleId;
  let role = '' as 'admin'|'user'|'customer'|'';
  if (typeof rawRole === 'string') {
    const s = rawRole.toLowerCase();
    // numeric string mapping as fallback
    if (s === '1') role = 'admin';
    else if (s === '2') role = 'user';
    else if (s === '3') role = 'customer';
    else if (s === 'admin' || s === 'user' || s === 'customer') role = s as any;
  } else if (typeof rawRole === 'number') {
    if (rawRole === 1) role = 'admin';
    else if (rawRole === 2) role = 'user';
    else if (rawRole === 3) role = 'customer';
  }
  const rawShelterId = (user as any)?.shelter?.shelterId ??
    (user as any)?.shelter?.shelter_id ??
    (user as any)?.shelter?.id ??
    (user as any)?.shelterId ??
    (user as any)?.shelter_id;
  const shelterId = rawShelterId !== undefined && rawShelterId !== null ? Number(rawShelterId) : undefined;
  const isAdminWithShelter = role === 'admin' && !!shelterId;
  return {
    user,
    token,
    isAuthenticated,
    logout,
    isAdmin: role === 'admin',
    isUser: role === 'user',
    isCustomer: role === 'customer',
    role,
    shelterId,
    isAdminWithShelter,
  };
};
